import { render, staticRenderFns } from "./drawerDetail.vue?vue&type=template&id=648dae95&scoped=true"
import script from "./drawerDetail.vue?vue&type=script&lang=js"
export * from "./drawerDetail.vue?vue&type=script&lang=js"
import style0 from "./drawerDetail.vue?vue&type=style&index=0&id=648dae95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dae95",
  null
  
)

export default component.exports